import { useState, useEffect, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';

import { formatNumber } from '../../utils/generalFunctions';

import { obtenerPaquete } from '../../actions/paquetes';

const DetallesPaquete = ({ paquete, reestablecerPaquete }) => {

    const dispatch = useDispatch();

    const { detalles } = useSelector(state => state.paquetes);

    const [detallesModal, setDetallesModal] = useState(false);

    const [paqueteData, setPaqueteData] = useState({
        id: null,
        paquete: null,
        total: null,
        fecha: null
    });

    const [servicios, setServicios] = useState([]);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Locatario',
            sortable: true,
            selector: row => row.locatario?.servicio ? `${row.locatario.servicio} (${row.locatario.nombre})` : (row.locatario?.nombre || 'Sin definir'),
            grow: 2
        },
        {
            name: 'Servicio',
            sortable: true,
            selector: row => row.nombre,
            grow: 2
        },
        {
            name: 'Cantidad contratada',
            sortable: true,
            selector: row => row.cantidad_total,
            center: true
        },
        {
            name: 'Citas usadas',
            sortable: true,
            selector: row => row.citas_usadas,
            center: true
        },
        {
            name: 'Citas disponibles',
            sortable: true,
            selector: row => row.citas_disponibles,
            center: true
        }
    ];

    const handleCerrar = () => {
        setPaqueteData({
            id: null,
            paquete: null,
            total: null,
            fecha: null
        });

        setServicios([]);
        setDetallesModal(false);
        reestablecerPaquete(null);
    }

    useEffect(() => {
        dispatch(obtenerPaquete(null));
    }, []);

    useEffect(() => {
        if(paquete){
            setDetallesModal(true);
            dispatch(obtenerPaquete(paquete?.id));
        }
    }, [paquete]);

    useEffect(() => {
        if(detalles){
            setPaqueteData({
                id: detalles?._id,
                paquete: detalles?.paquete,
                total: detalles?.total,
                fecha: detalles?.fecha
            });

            setServicios(detalles?.servicios || []);
        }
    }, [detalles]);

    return (
        <Fragment>
            <Modal show={detallesModal} backdrop="static" size="xl" centered onHide={() => handleCerrar()}>
                <Modal.Header closeButton>
                    <Modal.Title>Detalles del paquete</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label className="fw-bold">Paquete</label>
                            <p>{paqueteData?.paquete?.nombre || 'Sin definir'}</p>
                        </div>

                        <div className="col-md-4">
                            <label className="fw-bold">Costo</label>
                            <p>{formatNumber(paqueteData?.total || 0, 2, '$ ', '')}</p>
                        </div>

                        <div className="col-md-4">
                            <label className="fw-bold">Fecha de compra</label>
                            <p>
                                {
                                    paqueteData?.fecha
                                        ? new Date(paqueteData.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) +
                                          ' a las ' + new Date(paqueteData.fecha).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
                                        : 'Sin definir'
                                }
                            </p>
                        </div>
                    </div>

                    <DataTable
                        columns={columns}
                        data={servicios}
                        noDataComponent="No hay servicios registrados"
                        pagination
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[5, 10, 20]}
                        paginationComponentOptions={paginationOptions}
                        highlightOnHover={true}
                    />
                </Modal.Body>
            </Modal>
        </Fragment>
    )
}

export default DetallesPaquete;
